<div class="d-flex justify-content-between no-margin p-0">
  <div class="">
    <label> {{ 'maw.palletDetails.MAWB' | translate }} : {{ selectedMAWB }}</label>
    <div>
      <label>Mother Shipper Reference:</label
      ><input
        type="text"
        [(ngModel)]="mawbInvoiceReference"
        [value]="mawbInvoiceReference"
        (blur)="onMotherReference($event)" />
    </div>
  </div>
  <ng-container>
    <div *ngIf="!looseBbx" class="col-3">
      <label class="ml-3">
        {{ 'maw.palletDetails.palletID' | translate }}
        : {{ selectedPalletID }}</label
      >
    </div>
    <div class="col-3">
      <label class="ml-3">
        {{ 'maw.palletDetails.destinationCountryCode' | translate }}
        : {{ ctrycode }}</label
      >
      <div class="ms-3">
        <label>Invoice Number:</label>
        <input
          type="text"
          [(ngModel)]="mawbInvoiceNumber"
          [value]="mawbInvoiceNumber"
          (blur)="onMotherReference($event)" />
      </div>
    </div>
    <div class="col-3">
      <label class="ml-3">
        {{ 'maw.palletDetails.destinationServiceCode' | translate }}
        : {{ ctryServiceCode }}</label
      >
    </div>
  </ng-container>
  <div class="text-center icon-mat-close">
    <i mat-dialog-close class="bi bi-x"></i>
  </div>
</div>
<ng-container *ngIf="!this.looseBbx">
  <mat-tab-group mat-align-tabs="start">
    <mat-tab
      *ngIf="this.motherStatus == 'Open'"
      label="{{ 'maw.palletDetails.unlinkedShipments' | translate }}">
      <div class="d-flex">
        <div class="flex-grow-1">
          <input
            placeholder="{{ 'maw.palletDetails.shipmentIDPieceID' | translate }}"
            class="ml-2 width-filter"
            type="text"
            [(ngModel)]="box_id_forPrint"
            (keyup.enter)="onBoxID()"
            #boxinput />
        </div>
        <div class="text-end d-flex gap-3">
          <button
            class="primary-btn float-right"
            [disabled]="isPalletClosed"
            (click)="linkShipments1()">
            {{ 'maw.palletDetails.link' | translate }}
          </button>
        </div>
      </div>
      <div class="row m-1">
        <div class="custom-card">
          <div class="col-12 no-margin p-0 table-container">
            <table
              aria-label="linked"
              mat-table
              [dataSource]="dataSource1"
              matSort
              #unlinkedMatSort="matSort">
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox
                    (change)="$event ? toggleAllRows1() : null"
                    [checked]="selection1.hasValue() && isAllSelected1()"
                    [indeterminate]="selection1.hasValue() && !isAllSelected1()"
                    [aria-label]="checkboxLabel1()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection1.toggle(row) : null"
                    [checked]="selection1.isSelected(row)"
                    [aria-label]="checkboxLabel1(row)"
                    class="checkbox-select mt-2 mr-1">
                  </mat-checkbox>
                </td>
              </ng-container>

              <ng-container matColumnDef="shipmentID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.shipmentID' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.shipmentID }}
                </td>
              </ng-container>

              <ng-container matColumnDef="shipperReference">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.customerReference' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.shipperReference }}
                </td>
              </ng-container>

              <ng-container matColumnDef="pieceID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.pieceID' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.pieceID }}</td>
              </ng-container>
              <ng-container matColumnDef="shipmentDeclaredValueCurrency">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.shipmentDeclaredCurrency' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.shipmentDeclaredValueCurrency }}
                </td>
              </ng-container>
              <ng-container matColumnDef="destination_country">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.destinationCountryCode' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.destination_country }}
                </td>
              </ng-container>

              <ng-container matColumnDef="dest_srva_code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.destinationServiceCode' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.dest_srva_code }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns1; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns1"></tr>
              <tr class="mat-row justify-content-center" *matNoDataRow>
                {{
                  'maw.palletDetails.noDataAvailable' | translate
                }}
              </tr>
            </table>
            <mat-paginator
              #unlinkedPaginator
              [pageSizeOptions]="[15, 30, 45]"
              showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="{{ 'maw.palletDetails.linkedShipments' | translate }}">
      <div class="d-flex">
        <div class="flex-grow-1">
          <input
            placeholder="{{ 'maw.palletDetails.shipmentIDPieceID' | translate }}"
            class="ml-2 width-filter"
            type="text"
            [(ngModel)]="box_id_forPrintLinked"
            (keyup.enter)="onBoxIDLinked()"
            #boxinput />
        </div>
        <div class="text-end d-flex gap-3">
          <button
            *ngIf="this.motherStatus == 'Open'"
            class="primary-btn float-right"
            [disabled]="isPalletClosed"
            (click)="delinkPiece()">
            {{ 'maw.palletDetails.delink' | translate }}
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-6"></div>
      </div>

      <div class="row m-1">
        <div class="custom-card">
          <div class="col-12 no-margin p-0 table-container">
            <table
              aria-label="unlinked"
              mat-table
              [dataSource]="dataSource"
              matSort
              #linkedMatSort="matSort">
              <ng-container matColumnDef="select1">
                <th mat-header-cell *matHeaderCellDef>
                  <ng-container *ngIf="this.motherStatus == 'Open'">
                    <mat-checkbox
                      (change)="$event ? toggleAllRows() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                  </ng-container>
                </th>
                <td mat-cell *matCellDef="let row">
                  <ng-container *ngIf="this.motherStatus == 'Open'">
                    <mat-checkbox
                      (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)"
                      [aria-label]="checkboxLabel(row)"
                      class="checkbox-select mt-2 mr-1">
                    </mat-checkbox>
                  </ng-container>
                </td>
              </ng-container>
              <ng-container matColumnDef="shipmentID1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.shipmentID' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.shipmentID }}
                </td>
              </ng-container>

              <ng-container matColumnDef="shipperReference1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.customerReference' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.shipperReference }}
                </td>
              </ng-container>

              <ng-container matColumnDef="PieceID1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.pieceID' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element?.pieceID }}</td>
              </ng-container>

              <ng-container matColumnDef="shipmentDeclaredValueCurrency1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.shipmentDeclaredCurrency' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.shipmentDeclaredValueCurrency }}
                </td>
              </ng-container>

              <ng-container matColumnDef="ctryCode1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.destinationCountryCode' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.destination_country }}
                </td>
              </ng-container>

              <ng-container matColumnDef="serviceCode1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.destinationServiceCode' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element?.dest_srva_code }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              <tr class="mat-row text-center" *matNoDataRow>
                {{
                  'maw.palletDetails.noDataAvailable' | translate
                }}
              </tr>
            </table>
            <mat-paginator
              #linkedPaginator
              [pageSizeOptions]="[15, 30, 45]"
              showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</ng-container>

<ng-container *ngIf="this.looseBbx">
  <div class="row mb-1">
    <div class="col-12">
      <app-charges
        [additionalCharges]="additionalCharges"
        [invoiceReference]="invoiceReference"
        [mawb]="selectedMAWB"
        [isClosed]="this.motherStatus != 'Open'"
        *ngIf="hasChargesConfig"></app-charges>
      <!--
    <addtional-charges
      [setData]="additionalCharges"
      [mawb]="selectedMAWB"
      [isClosed]="this.motherStatus != 'Open'"
      *ngIf="hasChargesConfig"></addtional-charges>
    --></div>
  </div>
  <mat-tab-group mat-align-tabs="start">
    <mat-tab label="Baby Shipments List">
      <div class="row">
        <div class="col-6"></div>

        <div *ngIf="this.motherStatus == 'Open'" class="col-6">
          <button class="primary-btn float-right mr-2" (click)="lbbxDelinkShipment()">
            {{ 'maw.palletDetails.delink' | translate }}
          </button>
        </div>
      </div>

      <div class="row m-1">
        <div class="custom-card">
          <div class="col-12 no-margin p-0 table-container">
            <table
              aria-label="linked"
              mat-table
              [dataSource]="lbbxDataSource"
              matSort
              #lbbxLinkedMatSort="matSort">
              <ng-container matColumnDef="lbbxSelect">
                <th mat-header-cell *matHeaderCellDef>
                  <ng-container *ngIf="this.motherStatus == 'Open'">
                    <mat-checkbox
                      (change)="$event ? toggleAllRowsLbbx() : null"
                      [checked]="lbbxSelection.hasValue() && isAllSelectedLbbx()"
                      [indeterminate]="lbbxSelection.hasValue() && !isAllSelectedLbbx()"
                      [aria-label]="checkboxLabelLbbx()">
                    </mat-checkbox>
                  </ng-container>
                </th>
                <td mat-cell *matCellDef="let row">
                  <ng-container *ngIf="this.motherStatus == 'Open'">
                    <mat-checkbox
                      (click)="$event.stopPropagation()"
                      (change)="$event ? lbbxSelection.toggle(row) : null"
                      [checked]="lbbxSelection.isSelected(row)"
                      [aria-label]="checkboxLabelLbbx(row)"
                      class="checkbox-select mt-2 mr-1">
                    </mat-checkbox>
                  </ng-container>
                </td>
              </ng-container>

              <ng-container matColumnDef="lbbxShipmentID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.shipmentID' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.shipmentID }}
                </td>
              </ng-container>

              <ng-container matColumnDef="lbbxCustomerRef">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.customerReference' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.shipperReference }}</td>
              </ng-container>

              <ng-container matColumnDef="lbbxShipmentDeclCurrency">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.shipmentDeclaredCurrency' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.shipmentDeclaredValueCurrency }}
                </td>
              </ng-container>

              <ng-container matColumnDef="lbbxReceiver">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.receiver' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.receiverDetails[0]?.address_details.receiverCompanyName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="lbbxDestination">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.destination' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.receiverDetails[0]?.address_details.receiverCountryCode }}
                </td>
              </ng-container>

              <ng-container matColumnDef="lbbxStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'maw.palletDetails.status' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.status }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="lbbxDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: lbbxDisplayedColumns"></tr>
              <tr class="mat-row justify-content-center" *matNoDataRow>
                {{
                  'maw.palletDetails.noDataAvailable' | translate
                }}
              </tr>
            </table>
            <mat-paginator
              #lbbxLinkedPaginator
              [pageSizeOptions]="[15, 30, 45]"
              showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</ng-container>
